
import React, { useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { v4 as uuidv4 } from 'uuid';
import { FreeBreakfastOutlined } from '@material-ui/icons';
import Colors from '../utils/colors';


const useStyles = makeStyles((theme) => ({
    h1: {
        marginBottom: '5px',
        float: 'left',
    },
    h5: {
        float: 'left',  
    },
    infoIcon: {
        marginTop: '0px',
        width: '20px',
        height: '20px',
        color: Colors.darkBlue
    },

}));

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#E0F4FC",
        color: "rgba(0, 0, 0, 0.87)",
        maxWidth: 500,
        fontSize: theme.typography.pxToRem(11),
        border: "1px solid #dadde9"
    }
}))(Tooltip);

export default function InformationBox({ text, description, variant }) {
    const classes = useStyles();

    const label = (textValue) => {
        switch(variant){
            case 'h1':    
                return (<h1 className={classes.h1}>{textValue}</h1>);
            case 'h5':
                return (<Typography variant='h5' className={classes.h5}>{textValue}</Typography>)
            case '1rem':
                    return <span style={{fontSize: '1rem'}}>{textValue}</span>   
            default:
                return <>{textValue}</>    
        }
    
    }

    return (
        <div>
            {label(text)}<sup>
                <HtmlTooltip
                    title={
                        description.split('\n').map((item, key) => {
                            return <React.Fragment key={key}>{item}<br /></React.Fragment>
                        })
                    }
                >
                    <InfoIcon className={classes.infoIcon} />
                </HtmlTooltip>
            </sup>
        </div>

    );

}